import { createSlice } from '@reduxjs/toolkit'

const items =
    localStorage.getItem("cartItems") !== null
        ? JSON.parse(localStorage.getItem("cartItems"))
        : [];

const totalAmount =
    localStorage.getItem("totalAmount") !== null
        ? JSON.parse(localStorage.getItem("totalAmount"))
        : 0;

const totalQuantity =
    localStorage.getItem("totalQuantity") !== null
        ? JSON.parse(localStorage.getItem("totalQuantity"))
        : 0;

const setItemFunc = (item, totalAmount, totalQuantity) => {
    localStorage.setItem("cartItems", JSON.stringify(item));
    localStorage.setItem("totalAmount", JSON.stringify(totalAmount));
    localStorage.setItem("totalQuantity", JSON.stringify(totalQuantity));
};





export const cartReducer = createSlice({
    name: 'staff',
    initialState: {
        cartItems: items,
        totalQuantity: totalQuantity,
        totalAmount: totalAmount,
    },
    reducers: {
        // =========== add item ============
        addItem(state, action) {
            const newItem = action.payload;
            const id = action.payload.id;
            const newQuantity = action.payload.newQuantity;
            const extraIngredients = action.payload.extraIngredients;
            const existingItem = state.cartItems.find((item) => item.id === id);


            if (!existingItem) {
                state.cartItems.push({
                    id: newItem.id,
                    name: newItem.name,
                    image: newItem.image,
                    price: newItem.price,
                    quantity: newQuantity,
                    totalPrice: newItem.price,
                    extraIngredients: newItem.extraIngredients
                });
                state.totalQuantity++;

            } else {

                const value = JSON.parse(localStorage.getItem("cartItems"));
                let index = value.findIndex(s => s.id === existingItem.id);
                const newValue = {
                    id: existingItem.id,
                    name: existingItem.name,
                    image: existingItem.image,
                    price: existingItem.price,
                    quantity: newQuantity,
                    totalPrice: (newQuantity * existingItem.price),
                    extraIngredients: extraIngredients
                }
                state.cartItems.splice(index, 1, newValue);
                state.totalQuantity = state.cartItems.reduce(
                    (total, item) => total + Number(item.quantity),
                    0
                );
            }

            state.totalAmount = state.cartItems.reduce(
                (total, item) => total + Number(item.price) * Number(item.quantity),
                0
            );


            setItemFunc(
                state.cartItems.map((item) => item),
                state.totalAmount,
                state.totalQuantity
            );
        },



        // ========= remove item ========

        removeItem(state, action) {
            const id = action.payload;
            const existingItem = state.cartItems.find((item) => item.id === id);
            state.totalQuantity--;

            if (existingItem.quantity === 1) {
                state.cartItems = state.cartItems.filter((item) => item.id !== id);
            } else {
                existingItem.quantity--;
                existingItem.totalPrice =
                    Number(existingItem.totalPrice) - Number(existingItem.price);
            }

            state.totalAmount = state.cartItems.reduce(
                (total, item) => total + Number(item.price) * Number(item.quantity),
                0
            );

            setItemFunc(
                state.cartItems.map((item) => item),
                state.totalAmount,
                state.totalQuantity
            );
        },

        //============ delete item ===========

        deleteItem(state, action) {
            const id = action.payload;
            const existingItem = state.cartItems.find((item) => item.id === id);

            if (existingItem) {
                state.cartItems = state.cartItems.filter((item) => item.id !== id);
                state.totalQuantity = state.totalQuantity - existingItem.quantity;
            }

            state.totalAmount = state.cartItems.reduce(
                (total, item) => total + Number(item.price) * Number(item.quantity),
                0
            );
            setItemFunc(
                state.cartItems.map((item) => item),
                state.totalAmount,
                state.totalQuantity
            );
        },


        //============ delete card ===========

        deleteCard(state) {
            state.cartItems = [];
            state.totalQuantity = 0;
            state.totalAmount = 0;

            setItemFunc(
                state.cartItems,
                state.totalAmount,
                state.totalQuantity
            );
        },
    },


})
export const { messageClear } = cartReducer.actions
export const cartActions = cartReducer.actions;
export default cartReducer.reducer